<template>
  <div class="order-kpi-wrapper">
    <AgentAndStoreTab
      ref="agentAndStoreTabRef"
      v-if="!isInStoreRecord && hasStoreAuth('store_order_statistics')"
      v-model="agentStoreTab"
      type="order"
      @on-store-change="onAgentStoreChange"
      @on-load="onAgentStoreLoad"
    />
    <div
      @scroll="loadMore"
      class="order-kpi"
      ref="scrollContainer"
      :style="StoreHeaderStyle"
    >
      <!--order search bar-->
      <div
        class="filter-bar"
        id="order-search-bar"
        v-clickOutside="handelClickOutside"
      >
        <van-popover
          style="width: 100%; z-index: 10"
          :value="fuzzyPopover"
          placement="bottom-start"
          trigger="click"
          get-container="#order-search-bar"
        >
          <FuzzySearchPanel
            v-if="fuzzyPopover"
            ref="fuzzySearchPanel"
            @confirm="handleConfirmFuzzy"
            @getListSuccess="getListSuccess"
            :product-id="orderFilterParamsNew.productId"
            :typeText="typeText"
            fromType="order"
          />
          <template #reference>
            <div class="input-wrap" style="width: 100%">
              <span @click="focusAction">
                <img
                  src="@/assets/images/agent/search_s.png"
                  alt=""
                  class="search-icon"
                />
              </span>
              <input
                :key="showNameKey"
                @input="typeInputValue"
                v-model="orderFilterParamsNew.goodsName"
                class="type-input"
                type="text"
                @focus="focusAction"
                :placeholder="merchandisePlaceholder"
                ref="inputRef"
              />
              <i
                v-show="orderFilterParamsNew.goodsName"
                class="close"
                @click.self.stop="handleClear"
              ></i>
              <div
                v-if="getShowSearchBtn()"
                class="search-product-btn"
                @click.stop="searchProduct"
              >
                搜索
              </div>
            </div>
          </template>
        </van-popover>
      </div>
      <div style="margin-bottom: 12px">
        <VzanSearchBox
          ref="searchBoxRef"
          :search-opts="searchOpts"
          :filter-panel-opts="filterPanelOpts"
          @search="handleSearch"
          :resetClickFn="resetClickFn"
        >
          <template slot="extra">
            <div class="toggle-list-btn">
              <img
                src="@/assets/images/agent/storeTab/toggle_order_new.svg"
                alt=""
              />
            </div>
          </template>
        </VzanSearchBox>
      </div>
      <div data-flex="cross:center main:justify">
        <div data-flex="cross:center" v-show="total >= 1">
          订单列表<span class="total">（共{{ total }}笔订单）</span>
        </div>
        <div data-flex="cross:center">
          <span
            v-if="!goodsId"
            @click="handleOpenReport"
            class="download-text mr-24"
            :style="primaryColorStyle"
          >
            经营报表
          </span>
          <!-- v-if="isShowExport" 李雨濠说去掉 -->
          <span
            v-if="isShowExport"
            @click="handleExport"
            class="download-text mr-24"
            :style="primaryColorStyle"
          >
            导出数据
          </span>
          <span id="search-time">
            <van-popover
              v-model="showPopover"
              trigger="click"
              placement="bottom-end"
              get-container="#search-time"
            >
              <ul class="select-panel">
                <li
                  @click="onSelect(item)"
                  v-for="item in actions"
                  :key="item.value"
                  :class="[
                    'panel-item',
                    orderFilterParamsNew.serachTimeType === item.value &&
                      'active',
                  ]"
                >
                  {{ item.text }}
                </li>
              </ul>
              <template #reference>
                <van-icon name="descending" size="0.16rem" />
              </template>
            </van-popover>
          </span>
        </div>
      </div>
      <!--order list-->
      <div v-if="orderList.length" class="order-wrapper">
        <template v-for="(item, index) in orderList">
          <List
            v-if="listStyle === 1"
            :item="item"
            :showUser="true"
            :showFollow="true"
            :index="index"
            :key="item.id"
            @verify="handleVerifyGoods"
            @view="viewOrderDetails"
          />
          <CardList
            v-else
            :key="item.id"
            :order="item"
            :index="index"
            @verify="handleVerifyGoods"
            @view="viewOrderDetails"
          />
        </template>
      </div>
      <AgentEmpty v-else msg="暂无相关数据" />
      <!-- quantity of verification-->
      <InputDialog
        @confirm="handleVerifyNumConfirm"
        :options="{ title: '', placeholder: '请输入你要核销的数量' }"
        v-model="confirmVerifyDialogShow"
        :inputNum.sync="inputVerifyNum"
      >
        <div class="slot-header" slot="header">
          剩余<span class="remain-num">{{
            currentChildItem.remainVerifyNumber
          }}</span
          >个尚未核销
        </div>
      </InputDialog>
      <!-- order date picker -->
      <van-calendar
        v-model="showDatePicker"
        type="range"
        get-container="body"
        :min-date="minDate"
        :max-date="maxDate"
        :allow-same-day="true"
        @confirm="onDatePickerConfirm"
      />
      <!--下载中心-->
      <DownloadCenterButton :download-num="downloadNum" :showDown="true" />
      <!-- 门店中心 -->
      <AgetnCenterButton :show="isStore" top="4.3rem" />
      <!--经营报表弹窗-->
      <FilterPanelPopup
        v-if="operationStatementPopup"
        v-model="operationStatementPopup"
        @open="refreshOperationStatement"
        :hideButtonBar="true"
        class="custom-popup"
      >
        <OperationStatement
          ref="operationStatement"
          class="custom-wrapper"
          :isComponent="true"
          :store-id="mergedStoreId"
        />
      </FilterPanelPopup>
      <VerifyTips
        v-model="showVerifyTips"
        v-if="agentVerifyData"
        @confirm="confirmVerify"
        :verifyLoading="verifyLoading"
        :agentVerifyData="agentVerifyData"
      ></VerifyTips>
      <!--自定义时间选择-->
      <!--      <CustomDateTimePopup-->
      <!--        dateType="datetime"-->
      <!--        v-model="dateTimePopup"-->
      <!--        :beginDate="calcBeginDate"-->
      <!--        :overDate="calcOverDate"-->
      <!--        @confirm="handleConfirmDateTime"-->
      <!--        :sameYear="false"-->
      <!--      />-->
    </div>
  </div>
</template>

<script>
import DownloadCenterButton from './components/DownloadCenterButton'
import AgetnCenterButton from './components/AgetnCenterButton'
import List from './components/Order/List'
import CardList from './components/Order/CardList'
import { agentOrderMixins } from './js/mixins'
import InputDialog from './components/Integer/InputDialog'
import {
  DELIVERY_LIST,
  DELIVERY_TYPE,
  HX_TIPS,
  ORDER_LIST,
  ORDER_TYPE_LIST,
  ORDER_TYPE_ORDER_AND_OPERATION,
  VERIFY_STATUS_LIST,
} from './js/enum'
import {
  GetMyAgentOrderList,
  ExportAgentOrderList,
  saveAgentOrderUserType,
  getAgentOrderUserType,
  getAgentOrderGray,
} from '../../utils/http/modules/agent/order'
import { agentIsGray } from '@/utils/http/modules/agent/agent.request'
import moment from 'moment'
import {
  getEnv,
  isReachBottom,
  Ddebounce,
  setSession,
  getSession,
  removeSession,
  isInStoreRecord,
} from '../../utils/utils'
import AgentEmpty from './components/AgentEmpty'
import FuzzySearchPanel from './components/FuzzySearchPanel'
import { mapGetters } from 'vuex'
import muTypes from '@/store/mutation-types.js'
import FilterPanelPopup from './components/FilterPanelPopup'
import { agentCommonInfoMixins } from './js/mixins'
import OperationStatement from './operationStatement'
import VerifyTips from './components/VerifyTips'
import { agentStoreMixin } from '@/pages/agent/mixins/agentStore'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import { $shopApi } from '@/utils/http/modules/shop/shop.request'
import clickOutside from '@/directives/v-click-outside'
import storeConfigModel from '@/controllers/storeController/models/config/config.model'
import VzanSearchBox from '@/components/VzanSearchBox/index.vue'
import {
  DATE_TYPE,
  FILTER_PANEL_OPT_TYPE,
  INPUT_TYPE,
  OTHER_TYPE,
  SEARCH_BOX_TYPE,
} from '@/components/VzanSearchBox/enum'
import { debounce, cloneDeep } from 'lodash'

export default {
  name: 'OrderKPI',
  mixins: [agentCommonInfoMixins, agentOrderMixins, agentStoreMixin],
  components: {
    VzanSearchBox,
    OperationStatement,
    FilterPanelPopup,
    FuzzySearchPanel,
    InputDialog,
    DownloadCenterButton,
    AgetnCenterButton,
    List,
    CardList,
    AgentEmpty,
    VerifyTips,
  },
  directives: {
    clickOutside,
  },
  props: {
    storeId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      searchParams: {},
      filterPanelOpts: [
        {
          multiple: true,
          props: 'deliveryTypeList',
          label: '配送方式',
          tipPlacement: 'bottom-start',
          options: DELIVERY_LIST.map(item => {
            if (item.value === -1) {
              return {
                isAll: true,
                ...item,
              }
            }
            return {
              ...item,
            }
          }),
        },
        {
          multiple: true,
          props: 'orderStatusList',
          label: '订单状态',
          tipPlacement: 'bottom-start',
          options: ORDER_LIST.filter(
            item =>
              item.deliveryType == DELIVERY_TYPE.COMMODITY_DISTRIBUTION ||
              item.name == '全部'
          ).map(item => {
            if (item.value === -999) {
              return {
                isAll: true,
                name: item.name,
                value: item.value,
              }
            }
            return {
              name: item.name,
              value: item.value,
            }
          }),
        },
        {
          multiple: true,
          props: 'verifyStatusList',
          label: '订单核销状态',
          tipPlacement: 'bottom-start',
          tipWord: HX_TIPS,
          options: VERIFY_STATUS_LIST.map(item => {
            if (item.value === -1) {
              return {
                isAll: true,
                name: item.name,
                value: item.value,
              }
            }
            return {
              name: item.name,
              value: item.value,
            }
          }),
        },
        {
          multiple: true,
          props: 'orderSegmentType',
          label: '订单类型',
          tipPlacement: 'bottom-start',
          options: [...ORDER_TYPE_LIST, ...ORDER_TYPE_ORDER_AND_OPERATION].map(
            item => {
              if (item.value === null) {
                return {
                  isAll: true,
                  ...item,
                }
              } else {
                return item
              }
            }
          ),
        },
        {
          multiple: false,
          props: 'isAgentTakeOrder',
          label: '是否代客下单',
          tipPlacement: 'bottom-start',
          options: [
            { name: '全部', value: -1 },
            { name: '是', value: 1 },
            { name: '否', value: 0 },
          ],
        },
        {
          groupId: 1,
          filterType: FILTER_PANEL_OPT_TYPE.DATE,
        },
      ],
      storeAgentIds: [],
      operationStatementPopup: false,
      openDateTypeSelect: false,
      isShowDateSelect: false,
      downloadNum: 0,
      minDate: new Date(2008, 0, 1),
      maxDate: new Date(),
      loading: false,
      finished: false,
      showPopover: false,
      orderTimeTypeGray: false,
      actions: [
        { text: '下单时间从近到远', value: 0, key: 'searchOrderTime' },
        { text: '核销时间从近到远', value: 2, key: 'searchVerificationTime' },
      ],
      searchStatus: false,
      listQuery: {
        pageSize: 10,
        pageIndex: 1,
        startTime: moment(new Date())
          .subtract(7 - 1, 'days')
          .format('YYYY-MM-DD 00:00:00'),
        endTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      },
      showDatePicker: false,
      showFilterPopover: false,
      agentSetting: {},
      orderList: [],
      authData: {},
      fuzzyPopover: false,
      typeText: '',
      levelList: [],
      total: 0,
      showVerifyTips: false,
      agentVerifyData: {},
      customDate: [],
      listStyle: 0, // 0: 文字列表 1: 图文列表
      fuzzyMerchandiseSearchGray: false,
      scrollY: 0, // 记录滚动位置
      showNameKey: 0,
      // set_code_verify_new接口特殊参数，阿江让加的
      set_code_verify_new_special_params: Object.freeze({
        isBatchTask: false,
      }),
    }
  },
  computed: {
    ...mapGetters(['orderFilterParamsNew']),
    searchOpts() {
      return [
        [
          {
            type: SEARCH_BOX_TYPE.SELECT_INPUT,
            span: 18,
            smallSize: false, // 非必填
            options: [
              {
                value: 'nickName',
                name: '买家昵称',
              },
              {
                inputType: INPUT_TYPE.NUMBER,
                value: 'userId',
                name: '用户ID',
              },
              {
                inputType: INPUT_TYPE.NUMBER,
                value: 'topicId',
                name: '话题ID',
              },
              {
                inputType: INPUT_TYPE.NUMBER,
                value: 'orderId',
                name: '订单ID',
              },
              {
                inputType: INPUT_TYPE.NUMBER,
                value: 'followId',
                name: '代理ID',
              },
              {
                inputType: INPUT_TYPE.NUMBER,
                value: 'relevanceFollowId',
                name: '关联代理ID',
              },
              {
                value: 'phone',
                name: '收货手机号码',
              },
              {
                value: 'receiveUserName',
                name: '收货姓名',
              },
              {
                value: 'deliveryNo',
                name: '物流单号',
              },
              {
                value: 'tradeNo',
                name: '交易单号',
              },
              {
                value: 'orderNo',
                name: '商户单号',
              },
              // {
              //   value: 'userName',
              //   name: '用户昵称'
              // },
              // {
              //   value: 'agentName',
              //   name: '代理姓名'
              // }
            ],
          },
          {
            type: SEARCH_BOX_TYPE.FILTER,
            span: 6,
            smallSize: false,
          },
        ],
        [
          {
            groupId: 1,
            type: SEARCH_BOX_TYPE.MULTIPLE_COL_SELECT,
            span: 12,
            dateType: DATE_TYPE.DATETIME, // 时间类型
            selectLabelKey: 'dateParam',
            placement: 'bottom-start',
            smallSize: false,
            labelOptions: this.labelOptions,
            options: [
              {
                value: [
                  moment(new Date()).format('YYYY-MM-DD 00:00:00'),
                  moment(new Date()).format('YYYY-MM-DD 23:59:59'),
                ],
                name: '今日',
              },
              {
                value: [
                  moment(new Date())
                    .subtract(3 - 1, 'days')
                    .format('YYYY-MM-DD 00:00:00'),
                  moment(new Date()).format('YYYY-MM-DD 23:59:59'),
                ],
                name: '近 3 天',
              },
              {
                default: !this.orderTimeTypeGray,
                value: [
                  moment(new Date())
                    .subtract(7 - 1, 'days')
                    .format('YYYY-MM-DD 00:00:00'),
                  moment(new Date()).format('YYYY-MM-DD 23:59:59'),
                ],
                name: '近 7 天',
              },
              {
                default: this.orderTimeTypeGray,
                value: [
                  moment(new Date())
                    .subtract(30 - 1, 'days')
                    .format('YYYY-MM-DD 00:00:00'),
                  moment(new Date()).format('YYYY-MM-DD 23:59:59'),
                ],
                name: '近 30 天',
              },
              // {
              //   value: [
              //     moment(new Date())
              //       .subtract(90 - 1, 'days')
              //       .format('YYYY-MM-DD 00:00:00'),
              //     moment(new Date()).format('YYYY-MM-DD 23:59:59'),
              //   ],
              //   name: '近 90 天',
              // },
              {
                value: OTHER_TYPE.CUSTOM_DATE,
                name: '自定义',
                defaultBeginDate: moment(new Date())
                  .subtract(30 - 1, 'days')
                  .format('YYYY-MM-DD 00:00:00'),
                defaultEndDate: moment(new Date()).format(
                  'YYYY-MM-DD HH:mm:59'
                ),
              },
            ],
          },
          {
            span: 5,
            type: SEARCH_BOX_TYPE.RESET,
            smallSize: false,
          },
          {
            span: 4,
            type: SEARCH_BOX_TYPE.EXTRA,
            smallSize: false,
            clickEvent: this.toggleListStyle,
            extraSlotName: 'extra',
          },
        ],
      ]
    },
    labelOptions() {
      return [
        {
          default: true,
          value: 'searchOrderTime',
          name: '下单时间',
        },
        {
          value: 'searchVerificationTime',
          name: '核销时间',
        },
      ]
    },
    // * 当前是否门店系统客户模块
    isStore() {
      return StoreController.isStore(this)
    },
    StoreHeaderStyle() {
      return StoreController.headerStyle()
    },
    primaryColorStyle() {
      return StoreController.primaryColorStyle()
    },
    isShowExport({ agentSetting, authData }) {
      return agentSetting.showOrderDown == 1
    },
    isAdmin() {
      return (
        getEnv() == 'prod' ? ['CREATOR', 'ADMIN'] : ['CREATOR', 'ADMIN']
      ).some(v => window.userInfo.roles.includes(v))
    },
    goodsId() {
      return this.$route.query.productId
    },
    // 是否在门店报表中
    isInStoreRecord() {
      return isInStoreRecord()
    },
    merchandisePlaceholder() {
      return this.fuzzyMerchandiseSearchGray
        ? `【搜索】即模糊搜索包含该名称的订单`
        : `点击【搜索】即模糊搜索相关商品`
    },
    mergedStoreId() {
      const storeId =
        +this.agentStoreId || +this.storeId || +this.$route.query.storeId || 0
      return storeId
    },
    getDefaultDate() {
      return this.orderTimeTypeGray ? 30 : 7
    },
  },
  created() {
    this.getAgentOrderGray()
    this.getAgentOrderUserType()
  },
  async mounted() {
    console.log('mounted')
    await this.getOrderTimeTypeGray()
    this.searchParams = await this.$refs.searchBoxRef.getParamsAsync()
    this.initCacheParams(this.searchParams)
    this.initCouponFilterParams()
    this.initUrlParams()
    await this.$refs.searchBoxRef.setDefaultOptions(this.searchParams)
    this.handleDisplayLevelList(() => {
      this.getList()
    })
    setTimeout(() => {
      window.wx && window.wx.hideOptionMenu()
    }, 1500)
  },
  watch: {
    // 监听商品名称变化，这里监听是因为input事件作了防抖
    'orderFilterParamsNew.goodsName': {
      handler(newVal, oldVal) {
        this.searchStatus = false // 这里是为了防止搜索框输入时，搜索按钮显示
      },
      deep: true,
    },
  },
  methods: {
    // 这个地方处理缓存问题，先去拿本地存在字段值，然后赋值给searchParams
    initCacheParams() {
      let arr = [
        'nickName',
        'orderId',
        'userId',
        'topicId',
        'followId',
        'relevanceFollowId',
        'phone',
        'receiveUserName',
        'deliveryNo',
        'tradeNo',
        'orderNo',
      ]
      arr.forEach(item => {
        if (Reflect.has(this.orderFilterParamsNew, item)) {
          this.searchParams[item] = this.orderFilterParamsNew[item]
        } else {
          delete this.searchParams[item]
        }
      })
    },
    async getOrderTimeTypeGray() {
      const { dataObj } = await agentIsGray({
        businessType: 6,
        zbId: window.zbvd.zbid,
      })
      this.orderTimeTypeGray = dataObj
    },
    /** 处理时间筛选变量 */
    setOrderTimeAction() {
      const labelOptionsKey = this.labelOptions
        .map(item => item.value)
        .filter(ite => ite !== this.searchParams.dateParam)
      if (labelOptionsKey.length) {
        this.searchParams = this.removeKeysFromParams(
          this.searchParams,
          labelOptionsKey
        )
      }
      this.$store.commit(muTypes.updateOrderFilterParamsNew, {
        ...this.orderFilterParamsNew,
        ...this.searchParams,
        serachTimeType:
          this.searchParams.dateParam === 'searchVerificationTime' ? 2 : 0,
      })
    },
    onSelect(item) {
      const oldSerachTimeType = this.searchParams.dateParam
      const newSerachTimeType = item.key
      this.searchParams = Object.assign(this.searchParams, {
        dateParam: newSerachTimeType,
        [newSerachTimeType]: this.searchParams[oldSerachTimeType],
      })
      this.$store.commit(muTypes.updateOrderFilterParamsNew, {
        ...this.orderFilterParamsNew,
        ...this.searchParams,
        serachTimeType: item.value,
      })
      this.showPopover = false
      this.$refs.searchBoxRef.setDefaultOptions(this.searchParams)
      this.handleSearch()
    },
    getShowSearchBtn() {
      const { fuzzyPopover, searchStatus, orderFilterParamsNew } = this
      const { goodsName, productId } = orderFilterParamsNew
      const hasRequiredFields = fuzzyPopover && searchStatus && goodsName
      if (!hasRequiredFields) {
        return false
      }
      // 如果开启了模糊搜索，且商品名称不为空，则显示搜索按钮
      return !this.fuzzyMerchandiseSearchGray || !productId
    },
    handelClickOutside() {
      if (this.$refs.fuzzySearchPanel) {
        this.fuzzyPopover = false
      }
      this.$refs.inputRef && this.$refs.inputRef.blur()
      this.searchStatus = false
    },
    getListSuccess(state) {
      this.searchStatus = state
    },
    async getGoodsName(NameOrId, callback) {
      try {
        const { dataObj } = await $shopApi.getProList({
          ZbId: zbvd.zbid,
          sortBy: '',
          classId: 0,
          pageIndex: 1,
          pageSize: 10,
          NameOrId,
          storeDisplay: -1,
          state: -1,
          zbId: zbvd.zbid,
        })
        if (Array.isArray(dataObj) && dataObj.length) {
          typeof callback === 'function' && callback(dataObj[0].productName)
        }
      } catch (e) {
        console.log(e)
      }
    },
    storeAgentIdsChange(v) {
      this.storeAgentIds = v
      this.finished = false
      this.getList('search')
    },
    initCouponFilterParams() {
      if (getSession('orderFilterParams')) {
        this.$store.commit(
          muTypes.updateOrderFilterParamsNew,
          getSession('orderFilterParams')
        )
      }
    },
    initUrlParams() {
      this.orderFilterParamsNew.zbId = window.zbvd.zbid
      const {
        tpId,
        productId,
        goodsName,
        orderTime,
        isVerification,
        isDelivery,
        orderSegmentType,
        verifyStatusList,
        orderStatusList,
      } = this.$route.query
      if (verifyStatusList) {
        this.searchParams.verifyStatusList = JSON.parse(verifyStatusList)?.map(
          item => Number(item)
        )
      }
      if (tpId) {
        this.searchOpts[0][0].options[3].defalut = true
        this.searchParams['topicId'] = Number(tpId)
        this.$store.commit(muTypes.updateOrderFilterParamsNew, {
          ...this.orderFilterParamsNew,
          ...this.searchParams,
        })
      }
      if (productId) {
        this.orderFilterParamsNew.productId = Number(productId)
        this.getGoodsName(productId, name => {
          this.orderFilterParamsNew.goodsName = name
          this.$store.commit(muTypes.updateOrderFilterParamsGoodsName, name)
          this.showNameKey += 1
          // 这个地方存一次本地，因为存在异步故在最晚层存会存储不到最新的值
          setSession('orderFilterParams', {
            ...this.orderFilterParamsNew,
            ...this.searchParams,
          })
        })
        this.$store.commit(muTypes.updateOrderFilterParamsNew, {
          ...this.orderFilterParamsNew,
          ...this.searchParams,
        })
        document.title = '订单列表'
      }
      if (orderTime && this.searchParams.dateParam) {
        const timeType = this.searchParams.dateParam
        this.searchParams[timeType] = orderTime
        this.$store.commit(muTypes.updateOrderFilterParamsNew, {
          ...this.orderFilterParamsNew,
          ...this.searchParams,
        })
      }
      if (isVerification > 0) {
        this.searchParams.deliveryTypeList = [2, 10, 11]
        this.$store.commit(muTypes.updateOrderFilterParamsNew, {
          ...this.orderFilterParamsNew,
          ...this.searchParams,
        })
      } else if (isDelivery > 0) {
        this.searchParams.deliveryTypeList = [1]
        this.$store.commit(muTypes.updateOrderFilterParamsNew, {
          ...this.orderFilterParamsNew,
          ...this.searchParams,
        })
      }
      if (orderSegmentType && Array.isArray(orderSegmentType)) {
        const orderSegmentTypeListState =
          orderSegmentType.length === 1 && orderSegmentType[0] === null
        if (orderSegmentTypeListState) {
          this.searchParams.orderSegmentType = orderSegmentType
        } else {
          this.searchParams.orderSegmentType =
            (orderSegmentType.length &&
              orderSegmentType.map(item => Number(item))) ||
            []
        }
      }
      if (orderStatusList && Array.isArray(orderStatusList)) {
        const orderStatusListState =
          orderStatusList.length === 1 && orderStatusList[0] === null
        if (orderStatusListState) {
          this.searchParams.orderStatusList = orderStatusListState
        } else {
          this.searchParams.orderStatusList =
            (orderStatusList.length &&
              orderStatusList.map(item => Number(item))) ||
            []
        }
      }
      setSession('orderFilterParams', {
        ...this.orderFilterParamsNew,
        ...this.searchParams,
      })
    },
    handleClear() {
      this.orderFilterParamsNew.productId = ''
      this.orderFilterParamsNew.goodsName = ''
      this.orderFilterParamsNew.productName = void 0
      this.orderFilterParamsNew.productIds = []
      this.typeText = ''
      this.$nextTick(() => {
        if (this.$refs.fuzzySearchPanel) {
          this.$refs.fuzzySearchPanel.currentValue = ''
        }
      })
      this.handleSearch()
    },
    refreshOperationStatement() {
      this.$nextTick(() => {
        this.$refs.operationStatement._getOrderPerformanceSum()
      })
    },
    handleDisplayLevelList(callback) {
      this.fetchGetAgentAuth(data => {
        this.authData = data
        this.orderFilterParamsNew.followLevel = this.authData.level || 0
        this.fetchGetAgentSetting(dataObj => {
          this.agentSetting = dataObj
          // 处理等级列表展示
          this.handleLevelDisplay(
            levelList => {
              this.levelList = levelList
              // 李浩东说这块不需要了
              // if (this.authData.level == 1) {
              //   this.orderFilterParamsNew.followType = 1
              // }
              typeof callback === 'function' && callback()
            },
            this.authData,
            this.agentSetting
          )
        })
      })
    },
    typeInputValue: Ddebounce(function (e) {
      this.orderFilterParamsNew.productId = void 0
      this.orderFilterParamsNew.productIds = []
      this.typeText = e.target.value
    }, 1000),
    focusAction() {
      this.typeText = this.orderFilterParamsNew.goodsName || ''
      this.fuzzyPopover = true
    },
    handleConfirmFuzzy(item) {
      this.orderFilterParamsNew.goodsName = item.productName
      this.orderFilterParamsNew.productName = void 0
      this.orderFilterParamsNew.productId = item.id
      this.orderFilterParamsNew.productIds = [item.id]
      this.handleSearch()
      this.fuzzyPopover = false
    },
    handleOpenReport() {
      this.operationStatementPopup = true
      // this.$router.push({
      //   name: 'operationStatement',
      //   query: {
      //     zbid: window.zbvd.zbid
      //   }
      // })
    },
    loadMore(event) {
      const dom = event.target
      isReachBottom(
        dom,
        () => {
          this.getList()
        },
        100
      )
    },
    async handleExport() {
      await this.$dialog.confirm({
        title: '导出数据',
        message: '确定导出当前筛选结果的数据吗？',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonColor: '#006cff',
      })
      try {
        await ExportAgentOrderList(this.getCommonParams())
        this.downloadNum = 1
      } catch (e) {
        console.log(e)
        e && this.$toast(e)
      }
    },
    getCommonParams() {
      const storeId = this.mergedStoreId
      const labelOptionsKey = this.labelOptions.map(item => item.value)
      const timeType = this.searchParams.dateParam
      let params = {
        ...this.orderFilterParamsNew,
        selfTakeStoreId: storeId,
        storeId: storeId > 0 ? storeId : undefined,
        from: storeId > 0 ? 2 : undefined,
        ...this.searchParams,
        startTime: this.searchParams[timeType][0],
        endTime: this.searchParams[timeType][1],
        isAgentTakeOrder: this.searchParams.isAgentTakeOrder[0],
      }
      if (
        this.searchParams.deliveryTypeList.length === 1 &&
        this.searchParams.deliveryTypeList[0] === -1
      ) {
        params.deliveryTypeList = []
      }
      if (
        this.searchParams.orderStatusList.length === 1 &&
        this.searchParams.orderStatusList[0] === -999
      ) {
        params.orderStatusList = []
      }
      if (
        this.searchParams.orderSegmentType.length === 1 &&
        this.searchParams.orderSegmentType[0] === null
      ) {
        params.orderSegmentType = []
      }
      if (
        this.searchParams.verifyStatusList.length === 1 &&
        this.searchParams.verifyStatusList[0] === -1
      ) {
        params.verifyStatusList = []
      }
      if (this.storeAgentIds && this.storeAgentIds.length) {
        // params.storeAgentIds = this.storeAgentIds
        const userType = StoreController.storeUserType()
        params[storeConfigModel.STORE_AGENT_KEY[userType]] = this.storeAgentIds
      }
      // 门店系统-商品统计跳转时要带商品统计的区域/门店筛选条件
      let storeChildId = this.$route.query.storeChildId
      if (storeChildId) {
        const userType = StoreController.storeUserType()
        params[storeConfigModel.STORE_CHILD_KEY[userType]] =
          Number(storeChildId)
      }
      if (!params.orderId) {
        params.orderId = 0
      }
      if (!params.topicId) {
        params.topicId = 0
      }
      if (!params.userId) {
        params.userId = 0
      }
      if (!params.followId) {
        params.followId = 0
      }
      if (!params.followType) {
        params.followType = 0
      }
      if (!params.productId) {
        params.productId = 0
      }
      if (!params.followLevel) {
        params.followLevel = 1
      }
      // if (!params.deliveryNo) {
      //   params.deliveryNo = 0
      // }
      // if (!params.tradeNo) {
      //   params.tradeNo = 0
      // }
      if (params.phone) {
        params.phone = String(params.phone)
      }
      if (params.time) {
        delete params.time
      }
      if (labelOptionsKey.length) {
        params = this.removeKeysFromParams(params, labelOptionsKey)
      }
      if (params.dateParam) {
        delete params.dateParam
      }
      // 关联代理id 也是用followId入参 只是followType不同 followType：代理查询类型 0-跟进代理Id （默认）  1-关联代理Id
      if (params.followId) {
        params.followType = 0
      } else if (params.relevanceFollowId) {
        params.followType = 1
        params.followId = params.relevanceFollowId
      }
      return params
    },
    removeKeysFromParams(params, keys) {
      const newParams = cloneDeep(params)
      for (const key of keys) {
        delete newParams[key]
      }
      return newParams
    },
    async resetClickFn() {
      try {
        this.orderFilterParamsNew.productId = ''
        this.orderFilterParamsNew.goodsName = ''
        this.orderFilterParamsNew.productName = void 0
        this.orderFilterParamsNew.productIds = void 0
        let arr = [
          'nickName',
          'orderId',
          'userId',
          'topicId',
          'followId',
          'relevanceFollowId',
          'phone',
          'receiveUserName',
          'deliveryNo',
          'tradeNo',
          'orderNo',
        ]
        arr.forEach(item => {
          delete this.orderFilterParamsNew[item]
        })
        this.typeText = ''
        this.$nextTick(() => {
          if (this.$refs.fuzzySearchPanel) {
            this.$refs.fuzzySearchPanel.currentValue = ''
          }
        })
        removeSession('orderFilterParams')
        await this.$refs.searchBoxRef.reset()
        await this.$refs.searchBoxRef.search()
      } catch (e) {
        console.log(e)
      }
    },
    handleSearch(searchParams) {
      if (searchParams) {
        let arr = [
          'nickName',
          'orderId',
          'userId',
          'topicId',
          'followId',
          'relevanceFollowId',
          'phone',
          'receiveUserName',
          'deliveryNo',
          'tradeNo',
          'orderNo',
        ]
        arr.forEach(item => {
          delete this.orderFilterParamsNew[item]
        })
        this.searchParams = searchParams
      }
      this.refreshList('search')
      this.setOrderTimeAction()
      // this.$store.commit(muTypes.updateOrderFilterParamsNew, {
      //   ...this.orderFilterParamsNew,
      //   ...this.searchParams,
      // })

      setSession('orderFilterParams', {
        ...this.orderFilterParamsNew,
        ...this.searchParams,
      })
    },
    refreshList(type) {
      this.loading = false
      this.finished = false
      this.listQuery.pageIndex = 1
      this.getList(type)
    },
    // * 获取订单总条数
    async getListTotalNumber() {
      try {
        const res = await GetMyAgentOrderList({
          ...this.getCommonParams(),
          pageIndex: 1,
          isGetTotal: 1,
        })
        this.total = res.amout
      } catch (e) {
        e && this.$toast(e)
      }
    },
    getList: debounce(async function (type) {
      if (this.loading || this.finished) return
      if (type == 'search') {
        this.orderList = []
      }
      try {
        this.loading = true
        const pageIndex = type == 'totalNumber' ? 1 : this.listQuery.pageIndex
        const isGetTotal = type == 'totalNumber' ? 1 : 0
        const res = await GetMyAgentOrderList({
          ...this.getCommonParams(),
          searchTimeSortType: 0,
          pageIndex,
          isGetTotal,
        })
        if (pageIndex == 1) {
          if (type == 'totalNumber') {
            this.total = res.amout
            if (res.amout >= this.listQuery.pageSize) {
              this.finished = false
            } else {
              this.finished = true
            }
            this.loading = false
            return
          } else {
            this.loading = false
            this.finished = false
            try {
              this.getListTotalNumber()
            } catch (error) {
              console.log(error)
              this.total = -1
            }
          }
        }
        let dataObj = res.dataObj
        if (dataObj && dataObj.length) {
          let records = dataObj
          this.orderList = JSON.parse(
            JSON.stringify(this.orderList.concat(records))
          )
          if (dataObj.length < this.listQuery.pageSize) {
            this.finished = true
          } else {
            this.listQuery.pageIndex++
          }
        } else {
          this.finished = true
        }
        this.loading = false
      } catch (e) {
        console.log(e)
        if (type != 'totalNumber') {
          this.finished = true
          if (e instanceof Error) {
            this.$toast(e.message)
          } else {
            e && this.$toast(e)
          }
        }
        this.loading = false
      }
    }, 300),
    onDatePickerConfirm(value) {
      this.orderFilterParamsNew.startTime = moment(value[0]).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.orderFilterParamsNew.endTime = moment(value[1]).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      this.showDatePicker = false
      this.handleSearch()
    },
    onAgentStoreChange(storeId) {
      this.agentStoreId = storeId || void 0
      this.refreshList('search')
    },

    toggleListStyle() {
      this.$dialog
        .confirm({
          message: `是否切换${+this.listStyle === 1 ? '新' : '旧'}版视图`,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonColor: '#006cff',
        })
        .then(() => {
          this.listStyle = this.listStyle === 1 ? 0 : 1
          this.saveAgentOrderUserType()
        })
    },

    // 获取订单列表样式
    async getAgentOrderUserType() {
      try {
        const res = await getAgentOrderUserType({ zbId: window.zbid })
        if (res.code === 0) {
          this.listStyle = +res.dataObj || 0
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 保存订单列表样式
    async saveAgentOrderUserType() {
      try {
        await saveAgentOrderUserType({
          zbId: window.zbid,
          type: this.listStyle,
        })
      } catch (error) {
        console.log(error)
      }
    },

    searchProduct() {
      const panelRef = this.$refs.fuzzySearchPanel
      if (panelRef) {
        if (this.fuzzyMerchandiseSearchGray) {
          this.orderFilterParamsNew.productIds = void 0
          this.orderFilterParamsNew.productId = void 0
          this.orderFilterParamsNew.productName = this.typeText.trim()
        } else {
          // 未灰度的情况下，点击搜索全选列表中的商品
          this.orderFilterParamsNew.productIds = this.typeText.trim()
            ? panelRef.searchResultProductIds || []
            : []
          this.orderFilterParamsNew.productId = void 0
          this.orderFilterParamsNew.productName = void 0
        }
        this.handleSearch()
        this.fuzzyPopover = false
        this.searchStatus = false
      }
    },

    async getAgentOrderGray() {
      try {
        const res = await getAgentOrderGray({
          tenantId: window.zbvd.zbid,
          type: 0,
        })
        // console.log('订单灰度，', res)
        if (res.code == 0) {
          this.fuzzyMerchandiseSearchGray = res.dataObj
        }
      } catch (error) {
        console.log('error,', error)
      }
    },
  },
  activated() {
    this.initUrlParams()
    // 恢复滚动位置
    this.$nextTick(() => {
      if (this.$refs.scrollContainer) {
        // 使用requestAnimationFrame保证滚动生效
        this.$refs.scrollContainer.scrollTop = this.scrollY
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的滚动位置
    this.scrollY = this.$refs.scrollContainer?.scrollTop || 0
    next()
  },
}
</script>

<style lang="scss" scoped>
.order-kpi {
  width: 100%;
  background: #f5f7fa linear-gradient(180deg, #ffffff 0%, #f5f7fa 100%)
    no-repeat center top;
  background-size: 100% 136px;
  height: 100vh;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.order-wrapper {
  width: 100%;
}
.remain-num {
  color: #0070ff;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  margin: 0 4px;
}
.filter-module {
  &:not(:last-of-type) {
    margin-bottom: 18px;
  }
  .filter-name {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #202124;
    line-height: 14px;
    margin-bottom: 10px;
  }
  .filter-label-wrap {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    .label {
      min-width: 70px;
      padding: 0 4px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      box-sizing: border-box;
      background: #f5f6f7;
      border-radius: 6px;
      border: 1px solid transparent;
      &.active {
        color: #006cff;
        background: #fff;
        border-color: #006cff;
      }
    }
  }
}
.download-text {
  font-size: 13px;
  color: #006cff;
}
.filter-bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  .search_bar {
    flex: 1;
  }
}
//::v-deep {
//  .agent-empty {
//    height: 60%;
//  }
//  .select-button.active {
//    border-color: transparent;
//  }
//  .filter-button {
//    border: 1px solid #f5f7fa;
//  }
//}
.mr-24 {
  margin-right: 24px;
}
.input-wrap {
  display: flex;
  width: 100%;
  padding: var(--padding-padding-5, 10px) var(--padding-padding-8, 16px);
  align-items: center;
  gap: var(--padding-padding-4, 8px);
  background: #fff;
  border-radius: var(--radius-radius-5, 10px);
  border: 1px solid var(--color-Base-Black-100, #f5f7fa);
  background: var(--color-Base-White-800, #fff);
  box-sizing: border-box;
  .label {
    flex-shrink: 0;
    color: var(--color-Text-text-primary, #202124);
    /* 正文·14/14·Reagular */
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
  }
  .type-input {
    width: 100%;
    line-height: 22px;
  }
  .search-product-btn {
    box-sizing: border-box;
    padding: 6px 18px;
    background: #006cff;
    white-space: nowrap;
    color: #fff;
    font-size: 12px;
    border-radius: 6px;
  }
}
.toggle-list-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px;
  img {
    width: 32px;
    height: 32px;
  }
}
i.close {
  flex-shrink: 0;
  position: static;
  width: 14px;
  height: 14px;
  background: url('~@/assets/images/agent/search_close.png');
  background-size: 100% 100%;
}
::v-deep {
  .custom-popup .main-wrapper {
    padding: 0 !important;
  }
  .operation-statement {
    min-height: auto;
  }
}
#search-time {
  .select-panel {
    min-width: 160px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 10 60px 20px rgba(32, 33, 36, 0.08);
    border-radius: 12px;
    padding: 0 16px;
    box-sizing: border-box;
    .panel-item {
      width: 100%;
      padding: 16px 0;
      box-sizing: border-box;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #202124;
      line-height: 20px;
      text-align: left;
      font-style: normal;
      &.disabled {
        color: #c0c4cc;
      }
      &.active {
        color: #006cff;
      }
      &:not(:last-of-type) {
        border-bottom: 1px solid #f5f6f7;
      }
    }
  }
}
#order-search-bar {
  ::v-deep(.van-popover) {
    z-index: 1 !important;
  }
}
.search-icon {
  width: 21px;
  height: 21px;
}
</style>
